<template>
	<auth-shell>
		<h1 class="auth-title">Welcome back</h1>
		<p class="auth-subtitle">
			Sign in to Mission Control to manage municipalities, campaigns and clients.
		</p>

		<form @submit.prevent="login">
			<div class="auth-field">
				<label class="auth-label" for="email">Email</label>
				<div class="auth-input-group">
					<font-awesome-icon class="auth-input-icon" :icon="['fas', 'envelope']" />
					<input id="email" type="email" class="auth-input" placeholder="you@townweb.com,you@heygov.com" autocomplete="email" v-model="user.email" required />
				</div>
			</div>

			<div class="auth-field">
				<label class="auth-label" for="password">Password</label>
				<div class="auth-input-group">
					<font-awesome-icon class="auth-input-icon" :icon="['fas', 'lock']" />
					<input
						id="password"
						:type="showPassword ? 'text' : 'password'"
						class="auth-input auth-input--has-toggle"
						placeholder="Enter your password"
						autocomplete="current-password"
						minlength="3"
						v-model="user.password"
						required
					/>
					<button type="button" class="auth-input-toggle" :aria-label="showPassword ? 'Hide password' : 'Show password'" @click="showPassword = !showPassword">
						<font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
					</button>
				</div>
			</div>

			<div class="auth-row" style="justify-content: flex-end">
				<router-link class="auth-link" to="/forgot-password">Forgot password?</router-link>
			</div>

			<button v-if="!loading" type="submit" class="auth-btn">
				Sign in
				<font-awesome-icon :icon="['fas', 'arrow-right']" />
			</button>
			<button v-else type="button" class="auth-btn" disabled>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
				Signing in…
			</button>
		</form>
	</auth-shell>
</template>
<script>
import AuthShell from '../../components/auth/AuthShell.vue'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'Login',
	components: { AuthShell },
	data() {
		return {
			user: {
				email: null,
				password: null,
			},
			loading: false,
			showPassword: false,
		}
	},
	mounted() {
		window.addEventListener('message', this.onMessage, false)
	},
	beforeDestroy() {
		window.removeEventListener('message', this.onMessage)
	},
	methods: {
		/**
		 * @param {MessageEvent} e
		 */
		async onMessage(e) {
			if (e.data.source !== 'vue-devtools-proxy' && e.data.source !== 'vue-devtools-backend' && e.data.source !== 'vue-devtools-backend-injection') {
				// console.log(e.origin)
			}

			// TODO: Need bether way for this catching message for social login, bether url from config
			if (e.origin === 'http://127.0.0.1:8000') {
				this.$store.commit('SET_AUTH', e.data.token)
				window.removeEventListener('message', this.onMessage)
				this.$router.push('/')
			}
		},

		// Function to authenticate user with email and password
		async login() {
			this.loading = true
			await this.$store
				.dispatch('authLogin', this.user)
				.then(({ data }) => {
					if (data.success) {
						this.$router.push('/')
					}
					this.loading = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, 'login'),
						timer: 6000,
					})
					this.loading = false
				})
		},

		// Authenticate with Github Account
		async githubLogin() {
			const newWindow = openWindow('', 'Login')

			try {
				const url = await this.$store.dispatch('authLoginSocialite', 'github', this.user)
				newWindow.location.href = url
			} catch (error) {
				this.$swal.fire({
					icon: 'error',
					title: handleErrors(error, 'login'),
					timer: 6000,
				})
			} finally {
				this.loading = false
			}
		},

		// Authenticate with Google Account
		async googleLogin() {
			const newWindow = openWindow('', 'Login')

			try {
				const url = await this.$store.dispatch('authLoginSocialite', 'google', this.user)
				newWindow.location.href = url
			} catch (error) {
				this.$swal.fire({
					icon: 'error',
					title: handleErrors(error, 'login'),
					timer: 6000,
				})
			} finally {
				this.loading = false
			}
		},

		async facebookLogin() {
			const newWindow = openWindow('', 'Login')

			try {
				const url = await this.$store.dispatch('authLoginSocialite', 'facebook', this.user)
				newWindow.location.href = url
			} catch (error) {
				this.$swal.fire({
					icon: 'error',
					title: handleErrors(error, 'login'),
					timer: 6000,
				})
			} finally {
				this.loading = false
			}
		},
	},
}

/**
 * @param  {Object} options
 * @return {Window}
 */
function openWindow(url, title, options = {}) {
	if (typeof url === 'object') {
		options = url
		url = ''
	}
	options = { url, title, width: 600, height: 720, ...options }
	const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
	const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
	const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
	const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height
	options.left = width / 2 - options.width / 2 + dualScreenLeft
	options.top = height / 2 - options.height / 2 + dualScreenTop
	const optionsStr = Object.keys(options)
		.reduce((acc, key) => {
			acc.push(`${key}=${options[key]}`)
			return acc
		}, [])
		.join(',')
	const newWindow = window.open(url, title, optionsStr)
	if (window.focus) {
		newWindow.focus()
	}
	return newWindow
}
</script>
